export default {
  id: "potentialClientModal",
  code: "CN",
  text: {
    'Add Contact': '新增联系人',
    'Edit Contact': '编辑联系人',
		'Basic Information': '基本信息',
		'Name': '姓名',
		'Gender': '性别',
		'Date of Birth': '生日',
		'Tag': '标签',
		'Parent Name': '家长姓名',
		'Contact Number': '联系电话',
		'Remarks': '备注',
    'Save': '保存',
    'Cancel': '取消',
    'Male': '男',
    'Female': '女',
		'Add new tag for easier searching, ex: Language Class': '填写标签便于筛选与查找 ex: 语文初级班',
    'All Fields with * Must Be Filled': '带*号的字段必须填写',
		"Please press 'Enter' to create a new tag": "请按'Enter'来创建一个新标签",
    "Please enter a valid phone number": "请输入正确的电话号码",  
    "Other Info": "其他信息"
  }
}



// WEBPACK FOOTER //
// ./src/template/Modals/PotentialClient/locale.js